/**
 * Owner: Haselton Baker Risk Group, LLC
 * Product: SP3 - SP3-Risk-Model-UI
 * Developer: Mike McGlone <mike@hbrisk.com>
 * Date: 6/20/18
 * Copyright All Rights Reserved
 */
// @flow
import classNames from 'classnames';
import * as React from 'react';
import { Container } from 'reactstrap';
import {
  withRoomForHeader as withRoom,
  withoutRoomForHeader as withoutRoom,
} from './index.module.scss';

type Props = {
  children: React.Node,
  className?: string,
  withRoomForHeader?: boolean,
};

const MainContainer = ({ children, className, withRoomForHeader }: Props) => {
  const containerClasses = classNames(
    withRoomForHeader ? withRoom : withoutRoom,
    className
  );
  return (
    <Container className={containerClasses}>
      {children}
    </Container>
  );
};

MainContainer.defaultProps = {
  className: '',
  withRoomForHeader: true,
};

export default MainContainer;



// WEBPACK FOOTER //
// ./js/components/support/layout/MainContainer/index.jsx